import { Component, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { TabPageComponent } from '../tab-page/tab-page.component';

@Component({
  selector: 'crowdctrl-form-tab-page',
  standalone: true,
  imports: [TabPageComponent],
  template: `
    <crowdctrl-tab-page
      [pageTitle]="pageTitle"
      [defaultHref]="defaultHref"
      [backButtonIcon]="backButtonIcon"
      [showRefresh]="showRefresh"
      [loadFn]="loadFn"
      [refreshFn]="refreshFn"
      [contentScrollY]="contentScrollY"
      [reloadDataOnEachViewActivation]="reloadDataOnEachViewActivation"
      [toolbarColor]="toolbarColor"
      [progressBarColor]="progressBarColor"
      [contentClass]="contentClass"
    >
      <ng-content></ng-content>
    </crowdctrl-tab-page>
  `,
})
export class FormTabPageComponent {
  @ViewChild(TabPageComponent) private inner?: TabPageComponent;
  @Input() pageTitle = '';
  @Input() defaultHref: string | null = null;
  @Input() backButtonIcon?: string;
  @Input() showRefresh = false;
  @Input() loadFn?: () => Observable<unknown>;
  @Input() refreshFn?: () => Observable<unknown>;
  @Input() contentScrollY = true;
  @Input() reloadDataOnEachViewActivation = false;
  @Input() toolbarColor?: string;
  @Input() progressBarColor = 'medium';
  /**
   * Classes on `ion-content` (see `crowdctrl-tab-page`). Default `ion-padding` keeps form screens
   * inset. Use `ion-padding-bottom` for list-first / full-bleed headers (then set
   * `[padHorizontal]="true"` on {@link FormLayoutComponent} blocks that need side inset).
   */
  @Input() contentClass = 'ion-padding';

  onRefresh(force = false): void {
    this.inner?.onRefresh(force);
  }
}
